// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "e6e945c1fd1988a6ca62" + ".chunk.js";
};